"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.find.title': 'Alternar Búsqueda Web',
    'shortcuts.find.description': 'Habilita o deshabilita la funcionalidad de búsqueda web',
};
